import { Col, DisplayData, FormattedDate, Row } from '@elotech/components';
import React from 'react';

import { TipoRequerenteMp, TipoRequeridoMp } from '../../../types';

type Props = { processo: any };

const ProcedimentoInternoViewSection: React.FC<Props> = ({ processo }) => {
  return (
    <>
      <Row>
        <Col sm={6} md={6}>
          <DisplayData title="Data Autuação">
            <FormattedDate value={processo.processoMp?.dataAutuacao} />
          </DisplayData>
        </Col>
      </Row>
      <Row>
        <Col sm={4} md={4}>
          <DisplayData title="Tipo Requerido">
            {TipoRequeridoMp[processo.processoMp?.tipoRequerido]}
          </DisplayData>
        </Col>
        <Col sm={8} md={8}>
          <DisplayData title="Requerido">
            {processo.processoMp?.requerido}
          </DisplayData>
        </Col>
      </Row>
      <Row>
        <Col sm={4} md={4}>
          <DisplayData title="Tipo Requerente">
            {TipoRequerenteMp[processo.processoMp?.tipoRequerente]}
          </DisplayData>
        </Col>
        <Col sm={8} md={8}>
          <DisplayData title="Requerente">
            {processo.processoMp?.requerente}
          </DisplayData>
        </Col>
      </Row>
      <Row>
        <Col sm={5} md={5}>
          <DisplayData title="Distribuição">
            {processo.processoMp?.distribuicao?.nomeUsuario}
          </DisplayData>
        </Col>
        <Col sm={5} md={5}>
          <DisplayData title="Procedimento Origem">
            {processo.processoReferencia}
          </DisplayData>
        </Col>
      </Row>
    </>
  );
};

export default ProcedimentoInternoViewSection;
